export default __webpack_public_path__ + "static/media/CardDistortion.b7353d7a.svg";